import { MatchMode } from '../../types/types';

// These modes render no value input and are submitted with a boolean sentinel: isEmpty/isNotEmpty for strings, isNull/isNotNull for numeric and date-like types.
export const isValuelessMatchMode = (matchMode: MatchMode): boolean =>
  ['isEmpty', 'isNotEmpty', 'isNull', 'isNotNull'].includes(matchMode);
